<template>
    <div>
        <InquiryAnnouncement v-if="this.$route.query.biddingType==1"></InquiryAnnouncement>
        <TenderAnnouncement v-else></TenderAnnouncement>
    </div>
</template>
    
<script>
import InquiryAnnouncement from '@/views/show/InquiryAnnouncement.vue'
import TenderAnnouncement from '@/views/show/TenderAnnouncement.vue'
  export default {
    components: { InquiryAnnouncement ,TenderAnnouncement},
  };
  </script>
   